import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import SvgLoader from '../utils/SVGLoader';

const ReviewSection = (props) => {
    const content = props.content || {};
    return (
        <section className="bg-pf-bglight w-full relative flex flex-col items-center justify-center md:px-20 md:py-10 py-6">

            {/* Content */}
            <div className="flex flex-col justify-between md:justify-center items-center w-full h-full z-10 space-y-2">
                <div className="text-center">
                    <h1 className="text-pf-titleDark text-subtitle-sm md:text-subtitle md:pb-6">
                        {content.reviews.title}
                    </h1>
                </div>
            </div>
            <div className="wrapper md:p-6 py-6">
                <Swiper
                    spaceBetween={30}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                    className="!pb-20"
                    breakpoints={{
                        0: {
                            slidesPerView: 1.4,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 1.4,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 3.0,
                            spaceBetween: 50,
                            centeredSlides: false,
                        },
                    }}
                    centeredSlides={true}
                >
                    {content.reviews.items.map((item, index) => (
                        <SwiperSlide>
                            <div className='flex flex-col items-start w-full p-6' key={index}>
                                <div className='flex flex-row'>
                                    <img src={item.item.imageUrl} alt="Avatar" className="w-10 h-10 rounded-full" />
                                    <div className='flex flex-col items-start justify-center ml-4'>
                                        <div className='text-pf-titleDark text-sm font-semibold'>{item.item.name}</div>
                                        <div className='text-pf-titleDark text-sm'>{item.item.title}</div>
                                    </div>
                                </div>
                                <div className='w-full mt-5'>
                                    <SvgLoader url={content.reviews.starsSetUrl} />
                                </div>
                                <div className='w-full text-left text-base mt-4 h-[160px] overflow-hidden'>{item.item.review}</div>
                                <div className='w-full text-right text-base text-gray-500 mt-auto'>{item.item.footer}</div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section >
    );
}

export default ReviewSection;
